module.exports = require("jQuery");